import React, { ChangeEvent, HTMLInputTypeAttribute, useState } from 'react';
import { CLIENT_MOTOR_REQUEST } from '../../../constants';
import { Language } from '../../../enums';
import { useHook } from '../../../hooks';
import { useAppSelector } from '../../../hooks/common';
import Button, { ButtonType } from '../../common/Button';
import Flex, { FlexDirection, FlexJustification } from '../../common/Flex';
import Loader from '../../common/Loader';
import { InnoButton } from '@innomotics/innomotics-build-react-lib';

const TestClientDocument = () => {
    const loading = useAppSelector(state => state.motor.loading);
    const [clientMotorRequest, setClientMotorRequest] = useState(CLIENT_MOTOR_REQUEST);
    const { getClientDocument } = useHook(x => x.testPage)();
    const usedLanguages = [Language.En, Language.De];

    const onInputChange = (event: ChangeEvent<HTMLInputElement>, language?: Language) => {
        const { name, value, type, checked } = event.target;
        const castedValue = castInputToType(type, value, checked);

        if (language != undefined) {
            setClientMotorRequest({ ...clientMotorRequest, [name]: { ...(clientMotorRequest as any)[name], [Language[language].toLowerCase()]: castedValue } });
        } else {
            setClientMotorRequest({ ...clientMotorRequest, [name]: castedValue });
        }
    };

    const castInputToType = (type: HTMLInputTypeAttribute, value: string, checked?: boolean) => {
        switch (type) {
            case 'number':
                return Number(value);
            case 'checkbox':
                return checked ? true : false;
            default:
                return value;
        }
    };

    const renderLanguageValues = (label: string, name: string) => (
        <>
            <label>{label}</label>
            <Flex direction={FlexDirection.Column} justification={FlexJustification.SpaceBetween}>
                {usedLanguages.map(langauge => (
                    <div>
                        <label>{Language[langauge].toUpperCase()}</label>
                        <input
                            type='text'
                            onChange={e => onInputChange(e, langauge)}
                            name={name}
                            value={(clientMotorRequest as never)[name][Language[langauge].toLowerCase()]}
                        />
                    </div>
                ))}
            </Flex>
        </>
    );

    return (
        <Loader loading={loading}>
            <div className='test-page-container'>
                <div className='test-data-container'>
                    <div className='form-column'>
                        <div>
                            <label>Speed</label>
                            <input type='number' onChange={onInputChange} name='nN' value={clientMotorRequest.nN} title='Speed' />
                        </div>
                        <div>
                            <label>SYNC speed</label>
                            <input type='number' onChange={onInputChange} name='speed' value={clientMotorRequest.speed} title='SYNC speed' />
                        </div>
                        <div>
                            <label>Mlfb</label>
                            <input type='text' onChange={onInputChange} name='mlfb' value={clientMotorRequest.mlfb} />
                        </div>
                        <div>
                            <label>Kag</label>
                            <input type='text' onChange={onInputChange} name='options' value={clientMotorRequest.options} />
                        </div>
                        <div>
                            <label>Lang</label>
                            <input type='text' onChange={onInputChange} name='language' value={clientMotorRequest.language} />
                        </div>
                        <div>
                            <label>Frequency</label>
                            <input type='number' onChange={onInputChange} name='lineFrequency' value={clientMotorRequest.lineFrequency} title='Frequency' />
                        </div>
                        <div>
                            <label>Supply voltage</label>
                            <input type='number' onChange={onInputChange} name='lineVoltage' value={clientMotorRequest.lineVoltage} title='Supply voltage' />
                        </div>
                        <div>
                            <label>Calculate power</label>
                            <input type='number' onChange={onInputChange} name='pn' value={clientMotorRequest.pn} title='Calculate power' />
                        </div>
                        <div>
                            <label>Efficiency class</label>
                            <input type='text' onChange={onInputChange} name='efficiencyClass' value={clientMotorRequest.efficiencyClass} title='Efficiency class' />
                        </div>
                        <div>
                            <label>Voltage code</label>
                            <input type='text' onChange={onInputChange} name='voltageCode' value={clientMotorRequest.voltageCode} title='Voltage code' />
                        </div>
                        <div>
                            {renderLanguageValues('Winding', 'winding')}
                        </div>
                        <div>
                            {renderLanguageValues('AAD769', 'frameMaterial')}
                        </div>
                        <div>
                            <label>AAA726</label>
                            <input type='text' onChange={onInputChange} name='frameSize' value={clientMotorRequest.frameSize} title='AAA726' />
                        </div>
                        <div>
                            <label>AAA149</label>
                            <input type='number' onChange={onInputChange} name='poleNumber' value={clientMotorRequest.poleNumber} title='AAA149' />
                        </div>
                        <div>
                            <label>AAF197</label>
                            <input type='number' onChange={onInputChange} name='tStartWarm' value={clientMotorRequest.tStartWarm} title='AAF197' />
                        </div>
                        <div>
                            <label>AAF510</label>
                            <input type='number' onChange={onInputChange} name='tStartCold' value={clientMotorRequest.tStartCold} title='AAF510' />
                        </div>
                        <div>
                            <label>ABV064</label>
                            <input type='number' onChange={onInputChange} name='tBlockMaxWarm' value={clientMotorRequest.tBlockMaxWarm} title='ABV064' />
                        </div>
                        <div>
                            <label>ABV063</label>
                            <input type='number' onChange={onInputChange} name='tBlockMaxCold' value={clientMotorRequest.tBlockMaxCold} title='ABV063' />
                        </div>
                        <div>
                            <label>ACN903(HeatingTimeT1T2)</label>
                            <input type='number' onChange={onInputChange} name='heatingTimeT1T2' value={clientMotorRequest.heatingTimeT1T2} title='ACN903' />
                        </div>
                        <div>
                            <label>ACN904(HeatingTimeT3)</label>
                            <input type='number' onChange={onInputChange} name='heatingTimeT3' value={clientMotorRequest.heatingTimeT3} title='ACN904' />
                        </div>
                        <div>
                            <label>TEMPKLASSE</label>
                            <input type='number' onChange={onInputChange} name='temperatureClass' value={clientMotorRequest.temperatureClass} title='TEMPKLASSE' />
                        </div>
                        <div>
                            {renderLanguageValues('Explosion Protection', 'explosionProtection')}
                        </div>
                        <div>
                            {renderLanguageValues('Ausfuehrung', 'motorType')}
                        </div>
                        <div>
                            <label>ST2RTD torque</label>
                            <input type='number' onChange={onInputChange} name='maMn' value={clientMotorRequest.maMn} title='ST2RTD torque' />
                        </div>
                        <div>
                            <label>Connection</label>
                            <input type='number' onChange={onInputChange} name='connectionType' value={clientMotorRequest.connectionType} title='Connection' />
                        </div>
                        <div>
                            <label>BRK2RTD torque</label>
                            <input type='number' onChange={onInputChange} name='mkMn' value={clientMotorRequest.mkMn} title='BRK2RTD torque' />
                        </div>
                    </div>
                    <div className='form-column'>
                        <div>
                            <label>Torque</label>
                            <input type='number' onChange={onInputChange} name='mn' value={clientMotorRequest.mn} title='Torque' />
                        </div>
                        <div>
                            <label>Pullup torque</label>
                            <input type='number' onChange={onInputChange} name='ms' value={clientMotorRequest.ms} title='Pullup torque' />
                        </div>
                        <div>
                            <label>Speedputorquerpm</label>
                            <input type='number' onChange={onInputChange} name='ns' value={clientMotorRequest.ns} title='SPEEDPUTORQUERPM' />
                        </div>
                        <div>
                            <label>Udelta</label>
                            <input type='number' onChange={onInputChange} name='uDelta' value={clientMotorRequest.uDelta} title='UDelta' />
                        </div>
                        <div>
                            <label>UY</label>
                            <input type='number' onChange={onInputChange} name='uy' value={clientMotorRequest.uy} title='UY' />
                        </div>
                        <div>
                            <label>St2rtdcurrent</label>
                            <input type='number' onChange={onInputChange} name='iaIn' value={clientMotorRequest.iaIn} title='ST2RTDCURRENT' />
                        </div>
                        <div>
                            <label>Idelta</label>
                            <input type='number' onChange={onInputChange} name='iDelta' value={clientMotorRequest.iDelta} title='IDelta' />
                        </div>
                        <div>
                            <label>IY</label>
                            <input type='number' onChange={onInputChange} name='iy' value={clientMotorRequest.iy} title='IY' />
                        </div>
                        <div>
                            <label>I0delta</label>
                            <input type='number' onChange={onInputChange} name='i0Delta' value={clientMotorRequest.i0Delta} title='I0Delta' />
                        </div>
                        <div>
                            <label>I0y</label>
                            <input type='number' onChange={onInputChange} name='i0Y' value={clientMotorRequest.i0Y} title='I0Y' />
                        </div>
                        <div>
                            <label>Inertia torque</label>
                            <input type='number' onChange={onInputChange} name='j' value={clientMotorRequest.j} title='Inertia torque' />
                        </div>
                        <div>
                            <label>Startup type</label>
                            <input type='number' onChange={onInputChange} name='startingType' value={clientMotorRequest.startingType} title='Startup type' />
                        </div>
                        <div>
                            <label>Typical curr</label>
                            <input type='number' onChange={onInputChange} name='typicalCurrent' value={clientMotorRequest.typicalCurrent} title='Typical curr' />
                        </div>
                        <div>
                            <label>YD switch</label>
                            <input type='checkbox' onChange={onInputChange} name='yDSwitchPossible' checked={clientMotorRequest.yDSwitchPossible} title='YD switch' />
                        </div>
                        <div>
                            <p key='text-align: center; font-weight: bold;'>VSD related fields</p>
                        </div>
                        <div>
                            <label>Is Dol Operation</label>
                            <input type='checkbox' onChange={onInputChange} name='isDolOperation' checked={clientMotorRequest.isDolOperation} title='Is DOL operation' />
                        </div>
                        <div>
                            <label>Is Vsd Operation</label>
                            <input type='checkbox' onChange={onInputChange} name='isVsdOperation' checked={clientMotorRequest.isVsdOperation} title='Is VSD operation' />
                        </div>
                        <div>
                            <label>Framesize 63 - 450</label>
                            <input type='number' onChange={onInputChange} name='vsdFramesize' value={clientMotorRequest.vsdFramesize} title='Framesize 63 - 450' />
                        </div>
                        <div>
                            <label>Self ventilated</label>
                            <input type='text' onChange={onInputChange} name='ventilation' value={clientMotorRequest.ventilation} title='Ventilation IC411 or IC416' />
                        </div>
                        <div>
                            <label>Rated Speed</label>
                            <input type='number' onChange={onInputChange} name='vsdRatedSpeed' value={clientMotorRequest.vsdRatedSpeed} title='Rated Speed' />
                        </div>
                        <div>
                            <label>Rated Torque</label>
                            <input type='number' onChange={onInputChange} name='vsdRatedTorque' value={clientMotorRequest.vsdRatedTorque} title='Rated Torque' />
                        </div>
                        <div>
                            <label>Cutoff Frequency</label>
                            <input type='number' onChange={onInputChange} name='cutoffFrequency' value={clientMotorRequest.cutoffFrequency} title='Cutoff Frequency' />
                        </div>
                    </div>
                </div>
                <div className='form-submit'>
                    <InnoButton variant='primary' onClick={() => getClientDocument(clientMotorRequest)}>
                        <div>CREATE DOCUMENT</div>
                    </InnoButton>
                </div>
            </div>
        </Loader>
    );
};

export default TestClientDocument;
